export default __webpack_public_path__ + "static/media/OGJ-Type-Design-Sequel-Sans-Light-Obl-Body.3276b5eb.woff";